module.exports = __webpack_public_path__ + "img/banner_online_EN.3aadbb1a.png";